import { c as _c } from "react/compiler-runtime";
import type { BestContentsApiDto } from '__generated__/api/unauth/types.gen';
import { Fragment } from 'react';
import { SearchCategoryAdSlot } from '@/app/_components/ads';
import { ROUTES } from '@/constants';
import { buildDetailSlug } from '@/utils/detailSlug';
import { PREVIEW_SIZE } from '../../constants';
import { formatDateLabel } from '../../utils';
import { SearchContentsCard } from '../SearchContentsCard';
import { SearchContentsCardSkeletonList } from '../SearchContentsCardSkeleton';
import { SectionHeader } from './SectionHeader';
export function BestContentsPreviewSection(t0) {
  const $ = _c(11);
  const {
    keyword,
    items,
    totalCount,
    isLoading
  } = t0;
  if (!isLoading && items.length < 1) {
    return null;
  }
  let t1;
  if ($[0] !== keyword) {
    t1 = ROUTES.SEARCH.withSearchParams({
      searchParams: {
        q: keyword || undefined,
        category: "policy-info"
      }
    });
    $[0] = keyword;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1 || $[3] !== totalCount) {
    t2 = <SectionHeader title={"\uC815\uCC45 \uD65C\uC6A9 \uAC00\uC774\uB4DC"} totalCount={totalCount} moreHref={t1} />;
    $[2] = t1;
    $[3] = totalCount;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== isLoading || $[6] !== items) {
    t3 = isLoading ? <SearchContentsCardSkeletonList count={PREVIEW_SIZE} /> : <ul className="flex flex-col gap-12 mobile-tablet:gap-0 mobile-tablet:divide-y mobile-tablet:divide-Gray-100">{items.map((item, index) => <Fragment key={item.bestContentsIdIdx ?? item.bestContentsId}><SearchCategoryAdSlot as="li" placement="search-all-policy-guide" position={index + 1} listLength={items.length} className="mx-auto" /><li><SearchContentsCard imageSrc={item.emojiFileUrl || item.fileUrl} title={item.title} content={item.contentPreview} daysAgo={formatDateLabel(item.createAt) || item.daysAgo} link={ROUTES.POLICY_INFO_DETAIL.pathname({
            idIdx: item.slugId ?? buildDetailSlug(item.bestContentsIdIdx ?? "", item.title)
          })} /></li></Fragment>)}</ul>;
    $[5] = isLoading;
    $[6] = items;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <section className="flex w-full flex-col">{t2}{t3}</section>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}